import React from "react";
import { Link } from "react-router-dom";
import WhyImage from "../../assets/images/Why choose us (550x612).png";

function Whychoose() {
  const data = [
    {
      id: 1,
      name: "Customer-First Approach",
      desc: "Every policy, feature, and service is designed around your convenience.",
    },
    {
      id: 3,
      name: "Innovation You Can Trust",
      desc: "Smart digital tools that make buying and managing insurance effortless.",
    },
    {
      id: 2,
      name: "Committed to Clarity",
      desc: "We keep things simple, with no hidden terms or confusing jargon.",
    },
  ];
  return (
    <>
        <section className="about-four about-four--home-1" style={{ backgroundImage: "url(assets/images/shapes/about-4-h-1-bg.png)",}}>
          <div className="container">
            <img src={WhyImage} alt="Awesome Image"
              className="about-four--home-1__bg wow fadeInUp"
              data-wow-duration="1500ms"/>
            <div className="sec-title text-start">
              <p className="sec-title__tagline">Why choose us</p>

              <h3 className="sec-title__title">
                Bring your insurance idea with <br />
                professionals
              </h3>
            </div>

            <div className="row gutter-y-30">
              {data.map((item) => (
                <div
                  key={item.id}
                  className="col-md-12 col-lg-4 col-xl-3 wow fadeInUp"
                  data-wow-duration="1500ms"
                  data-wow-delay="000ms"
                >
                  <div className="about-four__card">
                    <div className="about-four__card__icon">
                      <i className="fas fa-check" />
                    </div>

                    <h3 className="about-four__card__title">
                      <Link to="#">{item.name}</Link>
                    </h3>

                    <div className="about-four__card__text">
                     {item.desc}
                    </div>

                    <div className="about-four__card__shape" />
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>
    </>
  );
}

export default Whychoose;
